import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const EQUIPO_JUEGOS_CONST = 'equipo_juegos';

export const allEquiposJuegosService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${EQUIPO_JUEGOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEquiposJuegosService = async (id, data) => {
  if (id) {
    return await axios.patch(
      `${juegosDeportivosApi}/${EQUIPO_JUEGOS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  }
  return await axios.post(
    `${juegosDeportivosApi}/${EQUIPO_JUEGOS_CONST}`,
    data,
    {
      headers: token({}),
    },
  );
};

export const oneEquiposJuegosService = async (id) => {
  const res = await axios.get(
    `${juegosDeportivosApi}/${EQUIPO_JUEGOS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};

export const deleteEquiposJuegosService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${EQUIPO_JUEGOS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
